import { render } from "./Register.vue?vue&type=template&id=5537107c&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=5537107c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5537107c"

export default script